import React, { Component } from 'react';
import { DRAGGABLE_ITEM_TYPES } from 'crazyEditor/core/constants/editorConstants';
import { DragSource } from 'react-dnd';
import MenuElement from './MenuElement';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { convertAbsolutePositionToRelative } from 'crazyEditor/components/EditorStage/MouseCatcher/MouseCatcherUtils';
import { LEFT_BAR_EXPANDED_WIDTH } from '../EditorLeftBarStyles';
import PropTypes from 'prop-types';
import Radium from 'radium';

const elementSource = {
  beginDrag(props) {
    return {
      elementType: props.elementType,
      elementPreset: props.elementPreset
    };
  },
  endDrag(props, monitor) {
    const dropPosition = monitor.getSourceClientOffset();
    let elementPosition = convertAbsolutePositionToRelative(dropPosition);
    const { stageLayoutHeight, left } = props;
    if (elementPosition.y < stageLayoutHeight) {
      if (elementPosition.x < parseInt(LEFT_BAR_EXPANDED_WIDTH.substr(0, LEFT_BAR_EXPANDED_WIDTH.search('px')), 10) - left ) {
        elementPosition = null;
      }
      props.onDrop(elementPosition);
    }
  }
};

function collectDrag(connect) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview()
  };
}

@DragSource(DRAGGABLE_ITEM_TYPES.ADD_PANEL_ELEMENT, elementSource, collectDrag)
@Radium
export default class DraggableMenuElement extends Component {
  componentDidMount() {
    // Use empty image as a drag preview so browsers don't draw it
    // and we can draw whatever we want on the custom drag layer instead.
    this.props.connectDragPreview(getEmptyImage(), {
      // IE fallback: specify that we'd rather screenshot the node
      // when it already knows it's being dragged so we can hide it with CSS.
      captureDraggingState: true
    });
  }

  render() {
    const { connectDragSource, onClick, ...other} = this.props;
    return connectDragSource(<li onClick={onClick} key={'el-' + this.props.elementType}>
      <MenuElement {...other} />
    </li>);
  }
}


MenuElement.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.node,
  templateTag: PropTypes.shape({
    name: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
  }),
  responsive: PropTypes.bool.isRequired,
  onDrop: PropTypes.func.isRequired,
};

MenuElement.defaultProps = {
  responsive: true,
};